export default function loggedIn($rootScope, $q) {
  let deferred = $q.defer();

  let openEvent = $rootScope.$on('$wamp.open', function () {
    deferred.resolve('logged in');
    openEvent();
  });

  return deferred.promise;
}
